import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import Em from 'ember';
function _loadContentWithSrcDoc(iframe, html) {
  iframe.srcdoc = sanitizeHtml(html, {
    config: 'email'
  });
  return new Em.RSVP.Promise(function (resolve) {
    iframe.addEventListener('load', function () {
      resolve(iframe);
    });
    document.body.appendChild(iframe);
  });
}
function _generateIframeElement(width) {
  let iframe = document.createElement('iframe');
  iframe.width = width;
  iframe.id = `tempstyles${Date.now()}`;
  iframe.style.visibility = 'hidden';
  iframe.style.position = 'fixed';
  return iframe;
}
export default function iframeContentLoader(html, width) {
  let iframe = _generateIframeElement(width);
  return _loadContentWithSrcDoc(iframe, html);
}